<template>
    <!-- 兑换活动管理－使用详情 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'detailCode')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="兑换码状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['status']">
                            <a-select-option value="1">未领取</a-select-option>
                            <a-select-option value="2">未使用</a-select-option>
                            <!-- <a-select-option value="3">已使用</a-select-option> -->
                            <a-select-option value="4">已过期</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="领取人手机号">
                        <a-input placeholder="请输入" v-decorator="['recipientsPhone']"></a-input>
                    </a-form-item>
                    <a-form-item label="领取时间">
                        <a-range-picker
                            style="width:282px"
                            showTime
                            format="YYYY/MM/DD HH:mm"
                            v-decorator="['pickupTime']"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset" class="mr8">重置</a-button>
                        <a-button @click="exportExcel" :loading="loading" type="primary">导出</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <div class="in_title">
                    <a-icon type="info-circle" />
                    兑换活动名称：{{detailData.activityName || '--'}}；兑换码张数：{{detailData.prizeNum || 0}} 张；未领取张数：{{detailData.unaccountedNums || 0}} 张；已过期张数：{{detailData.expiredNums || 0}}张
                </div>
                <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                :loading="loading"
                @change="changePage"
                :rowKey="record => record.id"
                >
                    <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                    <span slot="status" slot-scope="status">{{['','未领取','未使用','已使用','已过期'][status]}}</span>
                    <span slot="recipientsPhone" slot-scope="recipientsPhone">{{recipientsPhone || "-"}}</span>
                    <span slot="pickupTime" slot-scope="pickupTime">{{pickupTime || "-"}}</span>
                    <!-- <span slot="usageTime" slot-scope="usageTime">{{usageTime || "-"}}</span> -->
                    <span slot="action" slot-scope="a,row">
                        <a class="text-primary" @click="showCode(row.redemptionAddr)">兑换码查看</a>
                    </span>
                </a-table>
                <a-modal
                title="兑换码"
                v-model="visible"
                @ok="hideModal"
                :width="450"
                okText="下载"
                cancelText="取消"
                >
                    <div class="text-center">
                        <img :src="redemptionAddr" alt="">
                    </div>
                </a-modal>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "codeDetail",
        components: {},
        props: {},
        data() {
            const columns = [
            {
                title: "序号",
                key: "index",
                scopedSlots: { customRender: "index" }
            },
            {
                title: "兑换码状态",
                dataIndex: "status",
                scopedSlots: { customRender: "status" }
            },
            {
                title: "领取人手机号",
                dataIndex: "recipientsPhone",
                scopedSlots: { customRender: "recipientsPhone" }
            },
            {
                title: "领取时间",
                dataIndex: "pickupTime",
                scopedSlots: { customRender: "pickupTime" }
            },
            // {
            //     title: "使用时间",
            //     dataIndex: "usageTime",
            //     scopedSlots: { customRender: "usageTime" }
            // },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
            ];
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                detailData: {},
                visible: false,
                redemptionAddr: '',
                loading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return
                this.loading = true
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.shopId = this.shopId
                    values.prizeActivityId = this.$route.query.id

                    const pickupTime = values['pickupTime'] ? values['pickupTime'] : []
                    values.pickupTimeStart = pickupTime.length > 0 ? pickupTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.pickupTimeEnd = pickupTime.length > 0 ? pickupTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                    const usageTime = values['usageTime'] ? values['usageTime'] : []
                    values.usageTimeStart = usageTime.length > 0 ? usageTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.usageTimeEnd = usageTime.length > 0 ? usageTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                    delete values.pickupTime
                    delete values.usageTime

                    this.$api.changeCode
                    .details({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                        this.loading = false
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },
            statistics() {
                if(!this.shopId) return
                this.$api.changeCode
                .statistics({
                    params: {
                        prizeRedemptionId: this.$route.query.id,
                        shopId: this.shopId,
                    }
                })
                .then(res => {
                    this.detailData = res
                })
            },
            showCode(redemptionAddr) {
                this.visible = true
                this.redemptionAddr = redemptionAddr
            },
            hideModal() {
                let image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                image.onload = function() {
                    let canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    let context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                    let a = document.createElement("a"); // 生成一个a元素
                    let event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = name || "兑换码"; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = this.redemptionAddr;
            },
            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.shopId = this.shopId
                    values.prizeActivityId = this.$route.query.id

                    const pickupTime = values['pickupTime'] ? values['pickupTime'] : []
                    values.pickupTimeStart = pickupTime.length > 0 ? pickupTime[0].format('YYYY-MM-DD') : ''
                    values.pickupTimeEnd = pickupTime.length > 0 ? pickupTime[1].format('YYYY-MM-DD') : ''

                    const usageTime = values['usageTime'] ? values['usageTime'] : []
                    values.usageTimeStart = usageTime.length > 0 ? usageTime[0].format('YYYY-MM-DD') : ''
                    values.usageTimeEnd = usageTime.length > 0 ? usageTime[1].format('YYYY-MM-DD') : ''

                    delete values.pickupTime
                    delete values.usageTime

                    this.loading = true
                    this.$api.changeCode
                    .export({
                        body: Object.assign(values,
                        {
                            pageNum: 1,
                            pageSize: this.pagination.total,
                            shopId: values.searchShopId,
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            // type: "application/vnd.ms-excel"
                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xlsx'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },

        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList()
            this.statistics()
        },
        watch: {
            'shopId'() {
                this.getList()
                this.statistics()
            }
        }
    };
</script>
<style lang="scss">
</style>
